import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumbs — Home › Blog › Category › Article. Visual + provides the
 * BreadcrumbList JSON-LD (emitted from BlogPost.jsx, not from here).
 */
export function Breadcrumbs({ category, title }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-1.5 text-[13px] text-[#6B7280] mb-7 flex-wrap"
      data-testid="blog-breadcrumbs"
    >
      <Link to="/" className="hover:text-[#0066FF]">Home</Link>
      <ChevronRight className="w-3.5 h-3.5" />
      <Link to="/blog" className="hover:text-[#0066FF]">Blog</Link>
      {category ? (
        <>
          <ChevronRight className="w-3.5 h-3.5" />
          <Link
            to={`/blog?category=${encodeURIComponent(category)}`}
            className="hover:text-[#0066FF]"
          >
            {category}
          </Link>
        </>
      ) : null}
      {title ? (
        <>
          <ChevronRight className="w-3.5 h-3.5" />
          <span className="text-[#374151] line-clamp-1 max-w-[200px] sm:max-w-[360px]">{title}</span>
        </>
      ) : null}
    </nav>
  );
}
